import { FC, useRef, useState } from 'react';
import styles from './WebtoonQr.module.scss';

interface IWebtoonQr {
  externalId: number;
}

const WebtoonQr: FC<IWebtoonQr> = ({ externalId }) => {
  const QR_URL = 'https://fenzin01.b.litres.ru/api/v1/qr/';
  const [show, setShow] = useState(true);
  const refImg = useRef<HTMLImageElement>(null);

  fetch(`${QR_URL}${externalId}`)
    .then((res) => {
      if (res.ok) {
        return res.blob();
      }
      throw new Error('Error');
    })
    .then((blob) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (refImg.current !== null && reader.result) {
          refImg.current.setAttribute('src', `${reader.result}`);
        }
      };
      reader.readAsDataURL(blob);
    })
    .catch((error) => {
      console.log(error);
      setShow(false);
    });

  return (
    <>
      {show && (
        <div className={styles.webtoonQr}>
          <div className={styles.webtoonQr__img}>
            <img ref={refImg} src="/icons/book-no-cover.svg" alt="qr" />
          </div>
          <div className={styles.webtoonQr__desk}>
            <div className={styles.webtoonQr__title}>Вебтуны доступны по qr-коду</div>
            <div className={styles.webtoonQr__txt}>Наведите камеру телефона на QR-код для скачивания</div>
          </div>
        </div>
      )}
    </>
  );
};
export default WebtoonQr;
